const offset = 10;

const findVerticalCenter = (positionData) => {
  let deltaY = (positionData.bottom - positionData.top) / 2;
  let newY = positionData.top + deltaY;

  return newY - offset;
};

const findHorizontalCenter = (positionData) => {
  let deltaX = (positionData.right - positionData.left) / 2;
  let newX = positionData.left + deltaX;

  return newX - offset;
};

const getHorizontal = (positionData, horizontialOrientation) => {
  let elementLeft = 0;
  switch (horizontialOrientation) {
  case 'center':
    elementLeft = findHorizontalCenter(positionData);
    break;

  case 'left':
    elementLeft = positionData.left;
    break;
    
  case 'right':
    elementLeft = positionData.right;
    break;

  default:
    elementLeft = findHorizontalCenter(positionData);
    break;
  }
  return elementLeft;
};

const getVertical = (positionData, verticalOrientation) => {
  let elementTop = 0;
  switch (verticalOrientation) {
  case 'center':
    elementTop = findVerticalCenter(positionData);
    break;

  case 'top':
    elementTop = positionData.top;
    break;

  case 'bottom':
    elementTop = positionData.bottom - offset;
    break;
    
  default:
    elementTop = findVerticalCenter(positionData);
    break;
  }
  return elementTop;
};

const getPositioning = (
  elPositionData,
  verticalOrientation = 'center',
  horizontialOrientation = 'center'
) => {
  
  return ({
    top: getVertical(elPositionData, verticalOrientation),
    bottom: elPositionData.bottom,
    left: getHorizontal(elPositionData, horizontialOrientation),
    right: elPositionData.right,
    unadjusted: elPositionData
  });
};

export default getPositioning;